import ContentBlock from "../../components/UI/ContentBlock"
import ContentCard from "../../components/UI/ContentCard"
import {useEffect} from "react"
import Map from "./component/Map"
import CustomerReview from "../../components/CustomerReview"
import {useNavigate} from "react-router-dom"
import Trackers from "./component/Trackers"
import FAQ from "../../components/FAQ"
import ReadyToTry from "../../components/ReadyToTry"
import {Tiles, Tile} from "../../components/UI/Tiles"

const MonitoringScreen = () => {
	const navigate = useNavigate()

	useEffect(() => {
		document.title = 'АТС24 — Мониторинг транспорта, уровень топлива, температуры, скоростной режим'
	}, [])

	return (
		<>
			<ContentBlock top={3.33} bottom={0}>
				<div align="center">
					<h1>Мониторинг</h1>
					<p className="description">
						Местоположение, статусы точек, скоростной режим, контроль топлива и температуры.
					</p>
				</div>
			</ContentBlock>

			<Map/>

			<ContentBlock gap={2.22}>
				<h2>Выбор трекера</h2>
				<Trackers/>
			</ContentBlock>

			<ContentBlock background="#F1F9D8">
				<ContentCard title="Мониторинг доставки">
					<p className="description">
						Мы используем максимум от трекеров, накладывая фактический маршрут движения ТС на задания,
						которые они выполняют.
					</p>
				</ContentCard>
			</ContentBlock>

			<ContentBlock background="#F1F9D8" top={0}>
				<ContentCard
					title="Маршруты" size="small"
					media={{
						url: "/assets/img/jpg/monitoring/routes.jpg"
					}}
				>
					<p>
						Маршруты можно спланировать в нашем инструменте маршрутизации или импортировать готовые из ваших
						внутренних систем — 1С, МойСклад и других.
					</p>
				</ContentCard>

				<ContentCard title="Автоматические статусы" size="small" reverse
							 media={{
								 url: "/assets/img/jpg/monitoring/automount.jpg"
							 }}
				>
					<p>
						Водитель может включить опцию автоматических статусов, чтобы фиксация посещения точек
						происходила автоматически — на основании данных GPS-трекера или мобильного приложения.
					</p>
				</ContentCard>
				<ContentCard title="Журнал событий" size="small"
							 media={{
								 url: "/assets/img/jpg/monitoring/logs.jpg",
								 radius: 0,
							 }}
				>
					<p>
						Мы собираем все действия пользователей и храним их бессрочно. Для удобства все данные
						сгруппированы по маршрутным листам и точкам.
					</p>
				</ContentCard>

				<ContentCard
					title="Оперативный отчёт" size="small" radius={0} reverse
					media={{
						url: "/assets/img/jpg/monitoring/report.jpg",
						radius: 0
					}}
				>
					<p>
						В один клик логист может выгрузить все данные о доставках за выбранный период в файл Excel.
						Также доступны индивидуальные отчёты.
					</p>
				</ContentCard>
				<ContentCard title="Филиалы" size="small"
							 media={{
								 url: "/assets/img/jpg/monitoring/offices.jpg",
								 radius: 0
							 }}
				>
					<p>
						Перемещайтесь между вашими филиалами одним кликом мыши.
					</p>
					<p>
						Каждый филиал имеет индивидуальные настройки, логистов, водителей и парк транспортных средств.
					</p>
				</ContentCard>
			</ContentBlock>

			<ContentBlock>
				<CustomerReview
					author="Игорь Скатов, руководитель логистики"
					description="Удобный интерфейс, крутое приложение, поддержка 24 часа"
					media={{
						url: "/assets/img/png/monitoring/logo-grain.png"
					}}
				/>
			</ContentBlock>

			<ContentBlock background="#F5F5F5" bottom={0}>
				<ContentCard title="Мониторинг транспорта">
					<p className="description">
						Вы можете использовать АТС24 и как классическую систему мониторинга, без маршрутов.
					</p>
				</ContentCard>
			</ContentBlock>
			<ContentBlock background="#F5F5F5" top={2}>
				<ContentCard title="На карте" size="small"
							 media={{
								 url: "/assets/img/jpg/monitoring/vehicles.jpg"
							 }}
				>
					<p>
						Быстрый поиск нужного автомобиля, фильтры по площадкам и статусам транспортных средств.
					</p>
				</ContentCard>
				<ContentCard title="Трекбар" size="small" reverse
							 media={{
								 url: "/assets/img/jpg/monitoring/trackbar.jpg"
							 }}
				>
					<p>
						Уникальный инструмент, который позволяет быстро выделить любой участок маршрута и получить все
						ключевые показатели — расстояние, скорость, расход топлива и температурный режим.
					</p>
				</ContentCard>
				<ContentCard title="Учёт водителей" size="small"
							 media={{
								 url: "/assets/img/jpg/monitoring/drivers.jpg",
								 radius: 0
							 }}
				>
					<p>
						В карточке водителя отображается история использования транспортных средств.
					</p>
					<p>
						Система автоматически фиксирует смену водителей при использовании маршрутов.
					</p>
				</ContentCard>
				<ContentCard title="Отчёты" size="small" reverse radius={0}
							 media={{
								 url: "/assets/img/jpg/monitoring/moving-report.jpg",
								 radius: 0
							 }}
				>
					<p>
						АТС24 позволяет строить отчёты любой сложности и уровня вложенности.
					</p>
					<p>
						На примере — сводная таблица с распределением времени работы ТС: в пути, у клиента, на базе или
						в ремонте.
					</p>
				</ContentCard>
			</ContentBlock>

			<ContentBlock background="#dbf7ff" gap={2}>
				<ContentCard title="События в пути">
					<p className="description">
						Все события отражаются на карте так, чтобы их легко было понять с первого взгляда.
					</p>
				</ContentCard>
				<Tiles>
					<Tile>
						<img
							src="/assets/img/jpg/monitoring/sensor-gps.jpg"/>
						<h3>Скорость</h3>
						<p style={{fontSize: '1rem'}}>
							Система регистрирует все случаи превышения скорости свыше 85 км/ч, если они продолжаются
							дольше 20 секунд.
						</p>
					</Tile>
					<Tile>
						<img
							src="/assets/img/jpg/monitoring/sensor-fuel.jpg"/>
						<h3>Топливо</h3>
						<p style={{fontSize: '1rem'}}>
							Получая данные об уровне топлива через CAN-шину или ДУТ, система автоматически фиксирует
							заправки и возможные сливы, а также отправляет уведомления в <a
							onClick={() => navigate('/services/telegram')}>Telegram</a>.
						</p>
					</Tile>
					<Tile>
						<img
							src="/assets/img/jpg/monitoring/sensor-temp.jpg"/>
						<h3>Температурный режим</h3>
						<p style={{fontSize: '1rem'}}>
							Контролируйте температурный режим в рефрижераторах во время доставки <a
							onClick={() => navigate('/services/temperature')}>охлаждённых и замороженных продуктов</a>.
						</p>
					</Tile>
					<Tile>
						<img
							src="/assets/img/jpg/monitoring/sensor-gate.jpg"/>
						<h3>Открытие ворот</h3>
						<p style={{fontSize: '1rem'}}>
							Наш <a onClick={() => navigate('/services/telegram')}>Telegram-бот</a> оповестит о любом
							открытии ворот за пределами зон загрузки и выгрузки автомобиля.
						</p>
					</Tile>
				</Tiles>
			</ContentBlock>
			<ContentBlock>
				<ReadyToTry/>
			</ContentBlock>
			<ContentBlock background="#F5F5F5">
				<FAQ questions={[
					{
						label: 'Как маршруты попадают в АТС24?',
						children: 'Если вы используете встроенную маршрутизацию АТС24, маршруты автоматически появляются в системе мониторинга сразу после отправки в работу.\n' +
							'Если маршруты планируются во внешних системах (например, 1С), их можно легко загрузить в АТС24 через API или с помощью XLS-файла.'
					},
					{
						label: 'Можно установить датчики самостоятельно?',
						children: 'Да, установка датчиков не требует специальной квалификации. Мы предоставим инструкции и при необходимости проконсультируем на каждом этапе.'
					},
					{
						label: 'Что даёт датчик с CAN?',
						children: 'Датчик, подключённый к CAN-шине, позволяет получать внутренние данные о состоянии автомобиля: общий пробег, уровень топлива, ошибки и другие параметры. Однако не все транспортные средства поддерживают такую установку — перед покупкой рекомендуется проконсультироваться с нашими специалистами.'
					},
					{
						label: 'Мобильное приложение вместо GPS-датчика?',
						children: 'Да, мобильное приложение выполняет те же функции и может использоваться как альтернатива GPS-датчику. Однако следует учитывать, что водитель может выгрузить его из памяти — в этом случае передача координат остановится.'
					},
					{
						label: 'Расход аккумулятора у мобильного приложения',
						children: 'Средний расход заряда составляет 2–5% в час. Точное значение зависит от модели смартфона, состояния аккумулятора и настроек энергосбережения.'
					}
				]}/>
			</ContentBlock>
		</>
	)
}

export default MonitoringScreen